// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1_XHm","productName":"Table_productName__xBKYf"};